import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/ru/501/',
    component: ComponentCreator('/ru/501/', 'a74'),
    exact: true
  },
  {
    path: '/ru/articles/',
    component: ComponentCreator('/ru/articles/', '40b'),
    exact: true
  },
  {
    path: '/ru/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/ru/articles/2024/07/09/diskusija-lj-nj-cyrl/', '2ef'),
    exact: true
  },
  {
    path: '/ru/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/ru/articles/2024/07/09/diskusija-lj-nj/', '4e6'),
    exact: true
  },
  {
    path: '/ru/articles/archive/',
    component: ComponentCreator('/ru/articles/archive/', 'acd'),
    exact: true
  },
  {
    path: '/ru/articles/authors/',
    component: ComponentCreator('/ru/articles/authors/', 'fab'),
    exact: true
  },
  {
    path: '/ru/search/',
    component: ComponentCreator('/ru/search/', '113'),
    exact: true
  },
  {
    path: '/ru/',
    component: ComponentCreator('/ru/', '16f'),
    exact: true
  },
  {
    path: '/ru/',
    component: ComponentCreator('/ru/', '179'),
    routes: [
      {
        path: '/ru/',
        component: ComponentCreator('/ru/', 'd6c'),
        routes: [
          {
            path: '/ru/tags/',
            component: ComponentCreator('/ru/tags/', 'd35'),
            exact: true
          },
          {
            path: '/ru/tags/comparative/',
            component: ComponentCreator('/ru/tags/comparative/', '8e3'),
            exact: true
          },
          {
            path: '/ru/tags/grammar/',
            component: ComponentCreator('/ru/tags/grammar/', 'd30'),
            exact: true
          },
          {
            path: '/ru/tags/interslavic/',
            component: ComponentCreator('/ru/tags/interslavic/', '732'),
            exact: true
          },
          {
            path: '/ru/tags/language-learning/',
            component: ComponentCreator('/ru/tags/language-learning/', '4d6'),
            exact: true
          },
          {
            path: '/ru/tags/linguistics/',
            component: ComponentCreator('/ru/tags/linguistics/', 'b5e'),
            exact: true
          },
          {
            path: '/ru/tags/personal-pronouns/',
            component: ComponentCreator('/ru/tags/personal-pronouns/', 'a2f'),
            exact: true
          },
          {
            path: '/ru/tags/pronouns/',
            component: ComponentCreator('/ru/tags/pronouns/', '974'),
            exact: true
          },
          {
            path: '/ru/tags/slavic-languages/',
            component: ComponentCreator('/ru/tags/slavic-languages/', '683'),
            exact: true
          },
          {
            path: '/ru/tags/грамматика/',
            component: ComponentCreator('/ru/tags/грамматика/', '15e'),
            exact: true
          },
          {
            path: '/ru/tags/изучение-языка/',
            component: ComponentCreator('/ru/tags/изучение-языка/', 'b06'),
            exact: true
          },
          {
            path: '/ru/tags/межславянский-язык/',
            component: ComponentCreator('/ru/tags/межславянский-язык/', '5f4'),
            exact: true
          },
          {
            path: '/ru/tags/межславянский/',
            component: ComponentCreator('/ru/tags/межславянский/', '60d'),
            exact: true
          },
          {
            path: '/ru/tags/местоимения/',
            component: ComponentCreator('/ru/tags/местоимения/', 'd0b'),
            exact: true
          },
          {
            path: '/ru/tags/сравнение-языков/',
            component: ComponentCreator('/ru/tags/сравнение-языков/', '0ae'),
            exact: true
          },
          {
            path: '/ru/',
            component: ComponentCreator('/ru/', 'f7d'),
            routes: [
              {
                path: '/ru/learn/faq/',
                component: ComponentCreator('/ru/learn/faq/', 'c69'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/',
                component: ComponentCreator('/ru/learn/grammar/', '586'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/adjectives/',
                component: ComponentCreator('/ru/learn/grammar/adjectives/', '1bb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/conjunctions/',
                component: ComponentCreator('/ru/learn/grammar/conjunctions/', '23a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/nouns/',
                component: ComponentCreator('/ru/learn/grammar/nouns/', '1a0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/numerals/',
                component: ComponentCreator('/ru/learn/grammar/numerals/', '96d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/prepositions/',
                component: ComponentCreator('/ru/learn/grammar/prepositions/', '7c9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/pronouns/',
                component: ComponentCreator('/ru/learn/grammar/pronouns/', 'e99'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/syntax/',
                component: ComponentCreator('/ru/learn/grammar/syntax/', '36b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/grammar/verbs/',
                component: ComponentCreator('/ru/learn/grammar/verbs/', '4e6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/introduction/',
                component: ComponentCreator('/ru/learn/introduction/', 'bbb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/ru/learn/misc/constructed-slavic-languages/', 'ce2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/design-criteria/',
                component: ComponentCreator('/ru/learn/misc/design-criteria/', '44a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/history/',
                component: ComponentCreator('/ru/learn/misc/history/', '1e0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/language-comparison/',
                component: ComponentCreator('/ru/learn/misc/language-comparison/', '11e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/numbers-1-10/',
                component: ComponentCreator('/ru/learn/misc/numbers-1-10/', 'e44'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/ru/learn/misc/pan-slavic-relay/', 'b51'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/misc/personal-pronouns/',
                component: ComponentCreator('/ru/learn/misc/personal-pronouns/', '245'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/orthography/',
                component: ComponentCreator('/ru/learn/orthography/', '461'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/phonology/',
                component: ComponentCreator('/ru/learn/phonology/', '04d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/pronunciation/',
                component: ComponentCreator('/ru/learn/pronunciation/', 'fb1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/simple-grammar/',
                component: ComponentCreator('/ru/learn/simple-grammar/', 'd56'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/simple-grammar/level-1/',
                component: ComponentCreator('/ru/learn/simple-grammar/level-1/', '765'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/simple-grammar/level-2/',
                component: ComponentCreator('/ru/learn/simple-grammar/level-2/', '8f2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/vocabulary/derivation/',
                component: ComponentCreator('/ru/learn/vocabulary/derivation/', 'cd0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/ru/learn/vocabulary/flavourisation/', '423'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/learn/vocabulary/word-formation/',
                component: ComponentCreator('/ru/learn/vocabulary/word-formation/', '27b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/ru/resources/',
                component: ComponentCreator('/ru/resources/', '8fa'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/ru/resources/applets/',
                component: ComponentCreator('/ru/resources/applets/', 'fea'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/ru/resources/applets/intelligibility/',
                component: ComponentCreator('/ru/resources/applets/intelligibility/', 'f41'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/ru/resources/applets/transliterator/',
                component: ComponentCreator('/ru/resources/applets/transliterator/', 'd7f'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/ru/resources/keyboards/',
                component: ComponentCreator('/ru/resources/keyboards/', '179'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
